export function formatCurrency(value: number | null, digits: number = 2): string {
	if (value === null || isNaN(value)) {
		return 'N/A'
	}
	return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: digits }).format(
		value
	)
}

export function formatPercentage(value: number | null): string {
	if (value === null || isNaN(value)) {
		return 'N/A'
	}
	return `${value.toFixed(2)}%`
}

export function formatDate(value: Date | string | null): string {
	if (!value) {
		return 'N/A'
	}
	const date = new Date(value)
	const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' }
	return date.toLocaleDateString('en-US', options)
}

export function formatDateShort(value: Date | string | null): string {
	if (!value) {
		return 'Not Set'
	}
	const date = new Date(value)
	if (isNaN(date.getTime())) {
		return typeof value === 'string' ? value : 'Invalid Date'
	}
	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	})
}
